import { usePendingBidFeedback } from './usePendingBidFeedback';

/**
 * The cycle EOD feedback must target, as resolved by the server on
 * `GET /feedback/pending` (its `cycleId` is "the cycle the rows were resolved
 * against — what submit must target"; empty when no cycle is accepting).
 * Returns `undefined` when no cycle is accepting or the query hasn't resolved.
 *
 * Never derive this from the member's cycle history: more than one cycle can
 * be `active` at once (an older cycle stays active through judging while the
 * next one opens), and picking among them client-side silently skipped owed
 * feedback (GOTU-6571).
 *
 * Shares the pending-feedback query/cache (`bidKeys.pendingFeedback()`) with
 * the Today's-Shift tab, so the EOD gate and the dashboard agree on the cycle
 * by construction. On failure the query fails open (undefined → the gate
 * stays closed → the EOD flow is never blocked).
 */
export const useFeedbackCycleId = (enabled = true): string | undefined => {
  const query = usePendingBidFeedback(enabled);
  return query.data?.cycleId || undefined;
};
